export default __webpack_public_path__ + "static/ogX-d84650bffcff7ea47bd8ba0e3cd23ffa.jpg";